import CustomerService from "../../../../common/services/customer/CustomerService";
import { GET_CUSTOMER_WATCHLIST } from "./actions";

export default {
    /**
     * TODO change the state variable names and getters  to camelCase
     */
    state: {
        watchlist: [],
    },
    getters: {
        customerWatchlist: (state) => {
            return state.watchlist
        }
    },
    mutations: {
        [GET_CUSTOMER_WATCHLIST]: (state, data) => {
            state.watchlist = data;
        }
    },
    actions: {
        [GET_CUSTOMER_WATCHLIST]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerWathclist(context.getters.customer.id);
            context.commit(GET_CUSTOMER_WATCHLIST, results.data.data);
        },
    },
};